import _ from "lodash";

import {
  FilterByType,
  IFilterType,
  ModifiedDashboardFilter
} from "src/core/dashboard/api/dashboard.api";

import { DashboardGlobalFiltersState } from "../contexts/DashboardContext";

/**
 * A utility for taking dashboard filters response from an API request, and transforming the data into
 * state required for the dashboard's global filters context.
 */
const transformDashboardFilters = (dashboardFilters: ModifiedDashboardFilter[], filterTypes: IFilterType[]): DashboardGlobalFiltersState => {
  // prep global filters state object
  const updatedGlobalFilters: DashboardGlobalFiltersState = {
    dateRangeFilterTypeId: null,
    dateRangeOptions: null,
    filterByType: null,
    filterByValue: null,
    customer: null,
    drop: null
  };

  // Generate the filter preferences from get dashboard response
  // Duly note, as this loops over dashboardFilters, the filterByType and filterByValue will
  // be the the last matching iteration of either Customer or Drop. This ensures one of either set in state
  for (const filter of dashboardFilters) {
    const filterType = _.find(filterTypes, ft => ft.id === filter.filterTypeId);

    // set the dateRangeOptions if date range preferences set
    if (filter.filterValue.dateRange && filterType?.filterBy === FilterByType.DateRange) {
      updatedGlobalFilters.dateRangeOptions = filter.filterValue.dateRange;
      updatedGlobalFilters.dateRangeFilterTypeId = filterType.id;
    }

    // set filterBy to customer if customer data exists
    if (filter.filterValue.customer?.data && filterType?.filterBy === FilterByType.Customer) {
      updatedGlobalFilters.filterByType = filterType,
      updatedGlobalFilters.filterByValue = { id: filter.filterValue.customer.id },
      updatedGlobalFilters.customer = filter.filterValue.customer.data;
    }

    // replace filterBy with drop if drop data exists
    if (filter.filterValue.branch?.data && filterType?.filterBy === FilterByType.Branch) {
      updatedGlobalFilters.filterByType = filterType,
      updatedGlobalFilters.filterByValue = { id: filter.filterValue.branch.id },
      updatedGlobalFilters.drop = filter.filterValue.branch.data;
    }
  }

  return updatedGlobalFilters;
};

export default transformDashboardFilters;
